(() => {
  function alignControls(canvas) {
    canvas.querySelectorAll('.soeli-canva-tool').forEach(tool => {
      const image = tool.querySelector('img');
      if (!image) return;
      tool.style.width = `${image.offsetWidth}px`;
      tool.style.height = `${image.offsetHeight}px`;
    });
    canvas.querySelectorAll('[data-canva-button-box]').forEach(box => {
      const label = box.querySelector('[data-canva-button-label]');
      if (!label) return;
      label.style.transform = 'none';
      const outer = box.getBoundingClientRect();
      const inner = label.getBoundingClientRect();
      const scale = inner.width / label.offsetWidth;
      if (scale > 0) label.style.transform = `translateY(${(outer.y + outer.height / 2 - inner.y - inner.height / 2) / scale}px)`;
    });
  }
  function prepareMobile(canvas) {
    if (canvas.dataset.canvaWidth !== '390') return;
    const deadline = canvas.querySelector('[data-canva-deadline]');
    const deadlineBox = canvas.querySelector('[data-canva-deadline-box]');
    if (deadline && deadlineBox && !deadlineBox.querySelector('[data-canva-mobile-deadline]')) {
      const row = document.createElement('div');
      row.dataset.canvaMobileDeadline = '';
      row.innerHTML = '<svg class="soeli-canva-mobile-clock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 5v7l5 3"/></svg><span></span>';
      const text = row.querySelector('span');
      if (text) text.innerHTML = deadline.innerHTML;
      deadlineBox.append(row);
    }
    const consent = canvas.querySelector('[data-canva-consent-label]');
    const consentBox = canvas.querySelector('[data-canva-consent-box]');
    if (consent && consentBox && !consentBox.querySelector('[data-canva-mobile-consent]')) {
      const label = document.createElement('label');
      label.dataset.canvaMobileConsent = '';
      label.textContent = consent.textContent.trim();
      const checkbox = canvas.querySelector('.soeli-canva-consent');
      if (checkbox) {
        checkbox.style.cssText = 'position:absolute;left:-32px;top:2px;width:20px;height:20px';
        label.prepend(checkbox);
      }
      consentBox.append(label);
    }
  }
  function measure() {
    document.querySelectorAll('.soeli-canva-frame').forEach(frame => {
      const width = frame.clientWidth;
      const base = width < 768 ? 390 : 1366;
      let height = 0;
      frame.querySelectorAll('[data-canva-width]').forEach(canvas => {
        const active = Number(canvas.dataset.canvaWidth) === base;
        canvas.hidden = !active;
        if (active) {
          canvas.style.transform = `scale(${width / base})`;
          prepareMobile(canvas);
          alignControls(canvas);
          height = canvas.scrollHeight * width / base;
        }
      });
      frame.style.height = `${height}px`;
    });
  }
  const observer = new ResizeObserver(measure);
  function chooseFormat(target) {
    const format = target.closest('[data-canva-format]');
    const select = format?.closest('[data-product-root]')?.querySelector('[data-variant-select]');
    if (!format || !select) return;
    const option = Array.from(select.options).find(option => option.textContent.includes(format.dataset.canvaFormat));
    if (!option || option.disabled) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    format.closest('[data-product-root]').querySelectorAll('[data-canva-format]').forEach(item => item.setAttribute('aria-pressed', String(item === format)));
  }
  document.addEventListener('click', event => chooseFormat(event.target));
  document.addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-canva-format]')) {
      event.preventDefault();
      chooseFormat(event.target);
    }
  });
  document.querySelectorAll('.soeli-canva-frame').forEach(frame => observer.observe(frame));
  document.addEventListener('toggle', event => {
    if (event.target.matches('.soeli-canva-faq details')) measure();
  }, true);
  document.fonts.ready.then(measure);
  window.addEventListener('load', measure);
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.soeli-canva-frame').forEach(frame => observer.observe(frame));
    measure();
  });
  measure();
})();